class SummerIncentiveForm extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    var people = [] // Initialize an empty array
    var query = ''
    var selectedPerson = null
    var comboboxInput = this.querySelector('#combobox')
    var optionsContainer = this.querySelector('#options')
    let distributorButton = this.querySelector('#visit-distributor')

    function setQuery(event) {
      query = event.target.value
      if (query.length > 2) {
        filterPeople()
      }
    }

    function setSelectedPerson(person) {
      selectedPerson = person
      comboboxInput.value = selectedPerson ? selectedPerson.name : ''
      if (distributorButton.classList.contains('hidden')) {
        distributorButton.classList.remove('hidden')
      }
      distributorButton.href = selectedPerson.url
    }

    function extractPeopleFromOptions() {
      var options = optionsContainer.getElementsByTagName('li')
      people = Array.from(options).map(function (option) {
        return {
          url: option.getAttribute('data-url'),
          name: option.innerText,
        }
      })
    }
    optionsContainer.addEventListener('click', function (event) {
      var personURL = event.target.getAttribute('data-url')
      var personName = event.target.innerText
      setSelectedPerson({ url: personURL, name: personName })
      toggleOptionsContainerVisibility()
    })

    function toggleOptionsContainerVisibility() {
      optionsContainer.classList.toggle('hidden')
    }

    this.querySelector('#toggle').addEventListener('click', function () {
      toggleOptionsContainerVisibility()
    })

    // comboboxInput.addEventListener('focus', function () {
    //   toggleOptionsContainerVisibility()
    // })

    function filterPeople() {
      if (optionsContainer.classList.contains('hidden')) {
        toggleOptionsContainerVisibility()
      }

      var filteredPeople =
        query === ''
          ? people
          : people.filter(function (person) {
              var queryLower = query.toLowerCase()
              var nameLower = person.name.toLowerCase()
              return (
                nameLower.includes(queryLower) ||
                nameLower.replace(/\s/g, '').includes(queryLower)
              )
            })

      updateOptions(filteredPeople)
    }

    function updateOptions(people) {
      optionsContainer.innerHTML = ''

      people.forEach(function (person) {
        var option = document.createElement('li')
        option.className =
          'relative cursor-default select-none py-2 pl-3 pr-9 text-gray-900 hover:text-gold cursor-pointer'
        option.innerText = person.name.trim()
        option.setAttribute('role', 'option')
        option.setAttribute('tabindex', '-1')
        option.setAttribute('data-url', person.url) // Set data attribute for person ID

        people.forEach(function (person) {
          option.addEventListener('click', function () {
            setSelectedPerson(person)
          })
        })

        optionsContainer.appendChild(option)
      })
    }

    comboboxInput.addEventListener('input', setQuery)

    // Extract people from the existing combobox options
    extractPeopleFromOptions()

    return
  }
}

customElements.define('summer-incentive-form', SummerIncentiveForm)
